module.exports = __webpack_public_path__ + "img/cor_logo.f39cf9c5.png";